import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'kis-file-upload-block',
  templateUrl: './file-upload-block.component.html',
  styleUrls: ['./file-upload-block.component.scss']
})
export class FileUploadBlockComponent implements OnInit {

  /** Displays loader */
  @Input()
  loading = false;

  /** Handle files to upload */
  @Output()
  upload = new EventEmitter<File[]>();

  constructor() { }

  ngOnInit(): void {
  }

}
